import { useEffect, useMemo, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Chip } from "../../../../components";
import { MonitorFaturamentoService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";
import MonitorFatCard from "./monitor-fat-card.view";

const monitorFaturamentoService = new MonitorFaturamentoService();

const anoAtual = new Date().getFullYear();
const ANOS_DISPONIVEIS = [anoAtual];

const COR_ATUAL = "#1976d2";
const COR_ANTERIOR = "#94a3b8";

function MonitorFatMensalComparativo({ filtrosBody }) {
  const [ano, setAno] = useState(anoAtual);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ categories: [], series: [] });

  const body = useMemo(
    () => ({ filtros: { ...filtrosBody?.filtros, ano } }),
    [filtrosBody, ano],
  );

  useEffect(() => {
    buscarMensalComparativo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [body]);

  async function buscarMensalComparativo() {
    setLoading(true);
    const result = await monitorFaturamentoService.faturamentoMensalComparativo(
      body,
    );
    if (!result.isAxiosError) {
      setData(result.data || { categories: [], series: [] });
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const chartOptions = {
    chart: { type: "column", height: 300, spacing: [10, 10, 10, 10] },
    title: { text: "" },
    credits: { enabled: false },
    xAxis: {
      categories: data.categories,
      labels: { style: { fontSize: "10px" } },
    },
    yAxis: {
      title: { text: "" },
      labels: {
        style: { fontSize: "10px" },
        formatter: function () {
          return formatPrice(this.value);
        },
      },
    },
    legend: { enabled: true, itemStyle: { fontSize: "11px" } },
    tooltip: {
      shared: true,
      useHTML: true,
      backgroundColor: "#fff",
      borderWidth: 0,
      borderRadius: 4,
      formatter: function () {
        const rows = this.points
          .map(
            (p) =>
              `<span style="color:${p.color}">●</span> ${
                p.series.name
              }: <b>${formatPrice(p.y)}</b>`,
          )
          .join("<br/>");
        return `<b>${this.x}</b><br/>${rows}`;
      },
    },
    plotOptions: {
      column: { borderRadius: 3, dataLabels: { enabled: false } },
    },
    series: (data.series || []).map((s, i) => ({
      name: s.name,
      data: s.data,
      color: i === 0 ? COR_ATUAL : COR_ANTERIOR,
    })),
  };

  return (
    <MonitorFatCard
      titulo="Faturamento Mensal x Ano Anterior"
      icone="ph-calendar-blank"
      loading={loading}
    >
      <Box display="flex" gap={0.75} mb={1.5}>
        {ANOS_DISPONIVEIS.map((a) => (
          <Chip
            key={a}
            size="small"
            clickable
            variant={a === ano ? "filled" : "outlined"}
            color={a === ano ? "primary" : "default"}
            label={a}
            onClick={() => setAno(a)}
          />
        ))}
      </Box>
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </MonitorFatCard>
  );
}

export default MonitorFatMensalComparativo;
